export default {
      id: "blooksy-logo-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#blooksy-logo-usage",
      toString: function () {
        return this.url;
      }
    }